import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

export function useUrlSearchState(key = '') {
  const router = useRouter()
  const route = useRoute()

  const prefix = key ? `${key}_` : ''
  const qKey = `${prefix}q`
  const pageKey = `${prefix}page`

  const query = computed(() => route.query[qKey] || '')
  const page = computed(() => Number(route.query[pageKey] || 0))

  function push(q, p = 0) {
    router.replace({
      query: {
        ...route.query,
        [qKey]: q || undefined,
        [pageKey]: p || undefined,
      },
    })
  }

  return { query, page, push }
}
